import React, { useEffect, useMemo, useState } from 'react';
import { Section } from './shared';

// Initial target: 24h 58m 01s from first mount
const START_SECONDS = 24 * 3600 + 58 * 60 + 1;
function pad(n: number) {
  return String(n).padStart(2, '0');
}
export function Countdown() {
  const target = useMemo(() => Date.now() + START_SECONDS * 1000, []);
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const tick = () => {
      const diff = Math.max(0, Math.round((target - Date.now()) / 1000));
      setRemaining(diff);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);
  const hrs = Math.floor(remaining / 3600);
  const mins = Math.floor(remaining % 3600 / 60);
  const secs = remaining % 60;
  const units = [{
    value: pad(hrs),
    label: 'HS'
  }, {
    value: pad(mins),
    label: 'MIN'
  }, {
    value: pad(secs),
    label: 'SEG'
  }];
  return <div className="w-full bg-navy py-12" data-id="element-66" data-mp="15a4yk84kdre0">
      <Section data-id="element-67" data-mp="15927o078roy3">
        <p className="text-center font-display text-lg font-bold uppercase tracking-wide text-gold-soft sm:text-xl" data-id="element-68" data-mp="y0wtrj5afsjf">
          ⏰ Precio de lanzamiento — Cierra en:
        </p>
        <div className="mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-69" data-mp="t095344j7nsd">
          {units.map((u, i) => <React.Fragment key={u.label} data-id="element-70" data-mp="12rwnygn0vwi8" data-mpi={i}>
              <div className="flex flex-col items-center" data-id="element-71" data-mp="12t7takw49cbg">
                <div className="flex min-w-[72px] items-center justify-center rounded-xl bg-white/10 px-3 py-4 font-display text-3xl font-extrabold tabular-nums text-white sm:min-w-[96px] sm:text-5xl" data-id="element-72" data-mp="f22du6u38m1o">
                  {u.value}
                </div>
                <span className="mt-2 text-xs font-semibold tracking-widest text-blue-200 sm:text-sm" data-id="element-73" data-mp="o4k02l9qteoo">
                  {u.label}
                </span>
              </div>
              {i < units.length - 1 && <span className="font-display text-3xl font-extrabold text-gold sm:text-5xl" aria-hidden="true" data-id="element-74" data-mp="1zk8q5liamttp">
                  :
                </span>}
            </React.Fragment>)}
        </div>
      </Section>
    </div>;
}